import React from 'react';
import Header from './Header';
import Footer from './Footer';

const CustomizeCookies: React.FC = () => (
  <div className="page-container">
    <Header />
    <main className="page-content">
      <h1>Customize Cookies</h1>
      <p>
        You can customize your cookie preferences for Consphic at any time. Adjust your settings to allow or block different types of cookies according to your needs. For more information about how we use cookies, please see our Cookie Policy or contact our support team.
      </p>
    </main>
    <Footer />
  </div>
);

export default CustomizeCookies;
